//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

 /**
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param searchParameter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
 getAllAgentDetailsAsync(
    v: string, 
    searchType?: string | undefined | null, 
    fullTextFilter?: string | null | undefined, 
    pageIndex?: number | undefined, 
    includeMetricsDetails?: boolean | undefined,
    pageSize?: number | undefined, 
    sortColumn?: string | null | undefined, 
    sortAscending?: boolean | undefined,
    searchConditions?: string | undefined,
    impersonated_User?: any | undefined, 
    hOSTNAME?: any | undefined
  ): Promise<AgentDetailsResponse> {
     let url_ = this.baseUrl + "/api/contracting/v{v}/agentManagement/GetAllAgentManagementDetails?";
    if (v === undefined || v === null)
      throw new Error("The parameter 'v' must be defined.");
    url_ = url_.replace("{v}", encodeURIComponent("" + v)); 
    if (searchType !== undefined && searchType !== null && searchType !== "")
      url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
    if (fullTextFilter !== undefined && fullTextFilter !== null  && fullTextFilter !== "")
        url_ += "SearchText=" + encodeURIComponent("" + fullTextFilter)+ "&";
    if (includeMetricsDetails !== undefined)
      url_ += "IncludeMetricsDetails=" + encodeURIComponent("" + includeMetricsDetails) + "&";
    if (searchConditions !== undefined && searchConditions !== "")
      url_ += "FullTextFilter=" + encodeURIComponent("" + searchConditions) + "&";

    if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
    if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
    if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
    else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
    
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Impersonated_User:
          impersonated_User !== undefined && impersonated_User !== null
            ? "" + impersonated_User
            : "",
        HOSTNAME:
          hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetMetric(_response);
    });
  }

  protected processGetMetric(response: Response): Promise<AgentDetailsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as AgentDetailsResponse);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          "If Authorization header not present, has no value or no valid jwt bearer token",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "If user not authorized to perform requested action",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } 
    return Promise.resolve<AgentDetailsResponse>(null as any);
  }

  /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
  downloadAgents(
    v: string,
    impersonated_User?: any | undefined,
    hOSTNAME?: any | undefined,
    body?: DownloadAgentsRequestModel | undefined
  ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contracting/v{v}/agentManagement/DownloadAgents";
    if (v === undefined || v === null)
      throw new Error("The parameter 'v' must be defined.");
    url_ = url_.replace("{v}", encodeURIComponent("" + v));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
          "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
          "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          "Accept": "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAgentsResults(_response);
    });
  }

 
  protected processGetAgentsResults(response: Response): Promise<ReportFile> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 200) {
        return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
        return result200;
        });
    } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        });
    }
    return Promise.resolve<ReportFile>(null as any);
  }

   /**
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
 getupLineReporting(
  v: string, 
  fullTextFilter?: string | null | undefined, 
  impersonated_User?: any | undefined, 
  hOSTNAME?: any | undefined
): Promise<ReportingUpline> {
   let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/lookup?";
  if (v === undefined || v === null)
    throw new Error("The parameter 'v' must be defined.");
  url_ = url_.replace("{v}", encodeURIComponent("" + v)); 
  if (fullTextFilter !== undefined && fullTextFilter !== null  && fullTextFilter !== "")
      url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter)+ "&";

  
  url_ = url_.replace(/[?&]$/, "");

  let options_: RequestInit = {
    method: "GET",
    headers: {
      Impersonated_User:
        impersonated_User !== undefined && impersonated_User !== null
          ? "" + impersonated_User
          : "",
      HOSTNAME:
        hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
      Accept: "text/plain",
    },
  };

  return this.http.fetch(url_, options_).then((_response: Response) => {
    return this.processGetReportingUpline(_response);
  });
}

protected processGetReportingUpline(response: Response): Promise<ReportingUpline> {
  const status = response.status;
  let _headers: any = {};
  if (response.headers && response.headers.forEach) {
    response.headers.forEach((v: any, k: any) => (_headers[k] = v));
  }
  if (status === 200) {
    return response.text().then((_responseText) => {
      let result200: any = null;
      result200 =
        _responseText === ""
          ? null
          : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as ReportingUpline);
      return result200;
    });
  } else if (status === 401) {
    return response.text().then((_responseText) => {
      return throwException(
        "If Authorization header not present, has no value or no valid jwt bearer token",
        status,
        _responseText,
        _headers
      );
    });
  } else if (status === 403) {
    return response.text().then((_responseText) => {
      return throwException(
        "If user not authorized to perform requested action",
        status,
        _responseText,
        _headers
      );
    });
  } else if (status !== 200 && status !== 204) {
    return response.text().then((_responseText) => {
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    });
  } 
  return Promise.resolve<ReportingUpline>(null as any);
}

   /**
   * @param tenantName
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
   getlevelLookup(
    v: string, 
    tenantName?: string | null | undefined, 
    impersonated_User?: any | undefined, 
    hOSTNAME?: any | undefined
  ): Promise<LevelLookup> {
     let url_ = this.baseUrl + "/api/producer/v{v}/agents/hierarchylevelLookup?";
    if (v === undefined || v === null)
      throw new Error("The parameter 'v' must be defined.");
    url_ = url_.replace("{v}", encodeURIComponent("" + v)); 
    if (tenantName !== undefined && tenantName !== null  && tenantName !== "")
        url_ += "tenantName=" + encodeURIComponent("" + tenantName)+ "&";
  
    
    url_ = url_.replace(/[?&]$/, "");
  
    let options_: RequestInit = {
      method: "GET",
      headers: {
        Impersonated_User:
          impersonated_User !== undefined && impersonated_User !== null
            ? "" + impersonated_User
            : "",
        HOSTNAME:
          hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        Accept: "text/plain",
      },
    };
  
    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetLevelLookup(_response);
    });
  }
  
  protected processGetLevelLookup(response: Response): Promise<LevelLookup> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ReportingUpline);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          "If Authorization header not present, has no value or no valid jwt bearer token",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "If user not authorized to perform requested action",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } 
    return Promise.resolve<LevelLookup>(null as any);
  }

      /**
       * @param impersonated_User (optional)
       * @param hOSTNAME (optional) localhost:3000
       * @param body (optional)
       * @return Success
       */
      inviteAgent(
        v: string,
        impersonated_User?: any | undefined,
        hOSTNAME?: any | undefined,
        body?: InviteAgentModel | undefined
      ): Promise<boolean> {
        let url_ = this.baseUrl + "/api/contracting/v{v}/agentManagement/inviteAgent";
        if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);
        console.log("inviteAgent", content_);
        let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
            Impersonated_User:
              impersonated_User !== undefined && impersonated_User !== null
                ? "" + impersonated_User
                : "",
            HOSTNAME:
              hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            "Content-Type": "application/json",
            Accept: "text/plain",
          },
        };
    
        return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processInviteAgent(_response);
        });
      }
    
      protected processInviteAgent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
      }
}

export interface ReportFile {
  title?: string | undefined;
  data?: string | undefined;
  contentType?: string | undefined;
  fileName?: string | undefined;
}

export interface AgentDetailsResponse {
  agentDetails:AgentDetails | undefined | null;
  agentMetrics:AgentMetrics | undefined | null;
}
export interface AgentMetrics {
  allCount: number | undefined;
  activeCount: number | undefined;
  prospectiveCount: number | undefined;
  inActiveCount: number | undefined;
  terminatedCount: number | undefined; 
}
export interface AgentDetails {
    recordCount?: number;
    emailAllRecords?: null;
    data?: AgentsResponseModel[] | undefined;
}

export interface DownloadAgentsRequestModel {
  pageIndex?: number;
  pageSize?: number;
  sortColumn?: string | undefined;
  sortAscending?: boolean;
  fullTextFilter?: string | undefined;
  searchParameter?: string | undefined;
}

export interface AgentsResponseModel {
  agentId: number,
  agent?: string | undefined;
  agentStatus?: string | undefined;
  npn?: number | undefined;
  immediateUpline?:string | undefined;
  topOfHierarchy?:string | undefined;
  phoneNumber?:string | undefined;
  emailAddress?:string | undefined;
}

export interface ReportingUpline {
  recordCount: number;
  emailAllRecords?: null;
  data: ReportingUplineResponse[] | [];
}

export interface ReportingUplineResponse {
  city?: string | null;
  id: number;
  isAgency?: boolean;
  isLocation?: boolean;
  name?: string;
  npn?: string;
  state?: string | null;
  status?: string;
}

export interface LevelLookup {
  value: string | null;
  text: string | null;
  selected: boolean;
}

export interface InviteAgentModel {
   firstName: string | undefined;
   lastName: string | undefined;
   emailAddress: string | undefined;
   phoneNumber: string | undefined;
   writingAgentType: string | undefined;
   uplineAgentId:string | undefined;
   uplineNPN:string | undefined;
   levelId:string | undefined;
   tenantName: string | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
